import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicInstructionCycle = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="PHASES OF INSTRUCTION CYCLE"
      videos={[
        "https://www.youtube.com/embed/5jIg-D5gKtY",
      ]}
      takeaways={[
        { text: "Direct theory question (remember the flow chart and theory about each step)." },
      ]}
      questions={[]} // Ensure empty array
      exampleVideos={[]} // Ensure empty array
    />
);
}

export default ModuleSubtopicInstructionCycle;
